import { css } from '@emotion/react';
import { NO_BREAK_SPACE } from '~/_shared/constants/text.constants';
import type { Theme } from '~/_shared/themes/theme.model';

const rowStyle = ({ isBold }: { isBold?: boolean }) => (theme: Theme) => css({
  borderBottom: `1px solid ${theme.reportColors.borderPrimary}`,
  breakInside: 'avoid',
  color: theme.reportColors.textPrimary,
  fontWeight: isBold ? 700 : undefined,

  'tbody &:nth-of-type(2n)': {
    background: theme.reportColors.tableRowBackgroundPrimary,
  },
  'tbody &:nth-of-type(2n + 1)': {
    background: theme.reportColors.tableRowBackgroundSecondary,
  },
});

const tableDataCellStyle = ({ isError }: { isError?: boolean } = {}) => (theme: Theme) => css({
  textAlign: 'right',
  border: `0 solid ${theme.reportColors.borderPrimary}`,
  padding: 5,
  borderTopWidth: 0,
  borderBottomWidth: 0,
  color: isError ? 'red' : undefined,
  fontWeight: isError ? 700 : undefined,
  '&:first-of-type': {
    borderLeftWidth: 1,
    textAlign: 'left',
  },
  '&:last-of-type': {
    borderRightWidth: 1,
  },
  'tr:first-of-type &': {
    borderTopWidth: 1,
  },
  'tr:last-of-type &': {
    borderBottomWidth: 1,
  },
  'tr:first-of-type &:first-of-type': {
    borderRadius: '8px 0 0 0',
  },
  'tr:last-of-type &:first-of-type': {
    borderRadius: '0 0 0 8px',
  },
  'tr:first-of-type &:last-of-type': {
    borderRadius: '0 8px 0 0',
  },
  'tr:last-of-type &:last-of-type': {
    borderRadius: '0 0 8px 0',
  },
});

const additionalValueStyle = css({
  marginLeft: 15,
});

export type ExportReportTableValue = {
  value: string;
  additionalValue?: string | null;
  isError?: boolean;
};

type ExportReportTableDataRowProps = Readonly<{
  isBold?: boolean;
  isLabelError?: boolean;
  label: string;
  values: ReadonlyArray<ExportReportTableValue>;
}>;

export const ExportReportTableDataRowComponent = (props: ExportReportTableDataRowProps) => {
  return (
    <tr css={rowStyle({ isBold: props.isBold })}>
      <td css={tableDataCellStyle({ isError: props.isLabelError })}>
        {props.label}
        {!props.label && NO_BREAK_SPACE}
      </td>
      {props.values.map((item, index) => (
        <td key={index} css={tableDataCellStyle({ isError: item.isError })}>
          <span>
            {item.value}
          </span>

          {item.additionalValue && (
            <span css={additionalValueStyle}>
              {item.additionalValue}
            </span>
          )}
        </td>
      ))}
    </tr>
  );
};
